module.exports = __webpack_public_path__ + "img/reportIcon.81250535.png";